import { Injectable } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot } from "@angular/router";

import { InvalidOperationException } from "../exceptions/exceptions";
import { CustomRouteData, Type } from "../routes/shared/shared-route.constant";

@Injectable({ providedIn: "root" })
export class RouteDataService {
  // Important: 'ActivatedRoute' only works if it's directly injected into the component
  // for which the data has been added.
  // https://github.com/angular/angular/issues/11812
  // There are workarounds for that but they were evaluated as being an even worse solution.
  getProductSpecificCustomRouteData(
    activatedRoute: ActivatedRoute | ActivatedRouteSnapshot,
  ) {
    const customRouteData =
      activatedRoute instanceof ActivatedRoute
        ? (activatedRoute.snapshot.data as CustomRouteData)
        : (activatedRoute.data as CustomRouteData);

    if (customRouteData.type === Type.PRODUCT_SPECIFIC) {
      return customRouteData;
    }

    throw new InvalidOperationException(
      `The method 'getProductSpecificCustomRouteData' can only be called for pages with product specific route data`,
    );
  }

  getProductAgnosticCustomRouteData(
    activatedRoute: ActivatedRoute | ActivatedRouteSnapshot,
  ) {
    const customRouteData =
      activatedRoute instanceof ActivatedRoute
        ? (activatedRoute.snapshot.data as CustomRouteData)
        : (activatedRoute.data as CustomRouteData);

    if (customRouteData.type === Type.PRODUCT_AGNOSTIC) {
      return customRouteData;
    }

    throw new InvalidOperationException(
      `The method 'getProductAgnosticCustomRouteData' can only be called for pages with product agnostic route data`,
    );
  }

  getRequiredNavigationData(
    activatedRoute: ActivatedRoute | ActivatedRouteSnapshot,
  ) {
    return this.getProductSpecificCustomRouteData(activatedRoute).navigation;
  }
}
